<span class="float-left mt-2">{{mensaje}}</span>
<div class="snackButtonContainer" class="float-right" *ngIf="textoBoton">
    <button mat-raised-button color="primary" class="snackButton" (click)="ejecutar()">{{textoBoton}}</button>
</div>